<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Migrar Cadastro' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<app-loading-spinner *ngIf="!loaded"></app-loading-spinner>

<ion-content *ngIf="loaded">
  <ion-grid class="gradient-container">
    <div class="gradient-overlay"></div>

    <ion-row class="ion-justify-content-center">
      <ion-col size="auto">
        <img [src]="pessoa.foto | image:' '" class="image" />
      </ion-col>
    </ion-row>

    <ion-row class="ion-justify-content-center">
      <ion-col size="auto">
        <p class="nome-pessoa bold-2">{{pessoa.nome}}</p>

        <h2 class="nome-insti">
          {{pessoa.tipoPessoa}} <span *ngIf="pessoa.subTipoPessoa">-</span>{{pessoa.subTipoPessoa}}
        </h2>
      </ion-col>
    </ion-row>
  </ion-grid>

  <form
    class="sample-form validations-form"
    [formGroup]="validations_form"
    (ngSubmit)="onSubmit(validations_form.value)"
  >
    <ion-grid>
      <div class="gradient-extendido-div">
        <ion-label class="color-title"> {{'Dados da Migração' | translate}}</ion-label>
      </div>
      <ion-row class="ion-margin-end">
        <ion-col class="ion-margin-start">
          <ion-select
            interface="action-sheet"
            (ionChange)="mudarTipo($event);"
            cancelText="{{ 'Cancelar' | translate}}"
            okText="{{ 'Confirmar' | translate}}"
            formControlName="tipo"
            label-placement="stacked"
          >
            <div slot="label" class="label-normal">{{'Novo tipo' | translate}}</div>
            <ion-select-option *ngFor="let v of tipoList" [value]="v.id">{{v.nomenclatura}}</ion-select-option>
          </ion-select>

          <div class="validation-errors">
            <ng-container *ngFor="let validation of validation_messages.tipo">
              <div
                class="error-message"
                *ngIf="validations_form.get('tipo')?.hasError(validation.type) && (validations_form.get('tipo')?.dirty)"
              >
                {{ validation.message }}
              </div>
            </ng-container>
          </div>
        </ion-col>
      </ion-row>

      <ion-row class="ion-margin-end">
        <ion-col class="ion-margin-start" *ngIf="tipoSelecionado && subTipoList.length">
          <ion-select
            interface="action-sheet"
            cancelText="{{ 'Cancelar' | translate}}"
            okText="{{ 'Confirmar' | translate}}"
            formControlName="subtipo"
            label-placement="stacked"
          >
            <div slot="label" class="label-normal">{{'Subtipo' | translate}} <ion-text color="danger">*</ion-text></div>
            <ion-select-option *ngFor="let v of subTipoList" [value]="v.id">{{v.nome}}</ion-select-option>
          </ion-select>
          <div class="validation-errors">
            <ng-container *ngFor="let validation of validation_messages.subtipo">
              <div
                class="error-message"
                *ngIf="submit && validations_form.get('subtipo')?.hasError(validation.type) &&
              (validations_form.get('subtipo')?.dirty || validations_form.get('subtipo')?.touched)"
              >
                {{ validation.message }}
              </div>
            </ng-container>
          </div>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col class="ion-margin-start" *ngIf="!isVisitanteGrupos">
          <ion-toggle
            labelPlacement="start"
            [(ngModel)]="criarHistorico"
            (ionChange)="historico();"
            formControlName="criarHistorico"
            [enableOnOffLabels]="true"
            >{{'Criar histórico de migração?' | translate}}
          </ion-toggle>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-grid>
      <ion-row *ngIf="mostrarGrupo" class="ion-justify-content-center">
        <ion-col size="auto">
          <ion-button class="btn-default" expand="block" (click)="selecionarGrupo()">
            <ion-icon slot="start" name="people"></ion-icon>

            {{'Selecionar Grupos' | translate}}
            <ion-badge slot="end" color="danger">{{selectBadgeGrupos.length}}</ion-badge>
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-grid>
      <ion-row *ngIf="carteirinhas.length" class="ion-justify-content-center">
        <ion-col size="auto">
          <ion-button class="btn-default" expand="block" (click)="selecionarCarteirinha()">
            <ion-icon slot="start" name="people"></ion-icon>
            {{'Selecionar Carteirinhas' | translate}}
            <ion-badge slot="end" color="danger">{{carteirinhas.length}}</ion-badge>
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>

    <div *ngIf="tipoSelecionado.id == 3">
      <ion-grid>
        <div class="gradient-extendido-div">
          <ion-label class="color-title"> {{'Função' | translate}} </ion-label>
        </div>
        <ion-row class="ion-margin-end">
          <ion-col class="ion-margin-start">
            <ion-select
              interface="action-sheet"
              cancelText="{{ 'Cancelar' | translate}}"
              okText="{{ 'Confirmar' | translate}}"
              formControlName="cargo"
              label-placement="stacked"
            >
              <div slot="label" class="label-normal">{{'Função' | translate}}</div>
              <ion-select-option *ngFor="let v of cargoList" [value]="v.id">{{v.nome}}</ion-select-option>
            </ion-select>

            <div class="validation-errors">
              <ng-container *ngFor="let validation of validation_messages.cargo">
                <div
                  class="error-message"
                  *ngIf="validations_form.get('cargo')?.hasError(validation.type) && (validations_form.get('cargo')?.dirty)"
                >
                  {{ validation.message }}
                </div>
              </ng-container>
            </div>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col>
            <prover-datepicker
              [labelName]="'Data de Início'"
              [id]="'dataCargo'"
              formControlName="dataCargo"
              [required]="true"
              [isDataAtual]="false"
              [disabled]="validations_form.get('dataCargo')?.disabled ?? false"
            ></prover-datepicker>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>

    <div *ngIf="criarHistorico">
      <ion-grid>
        <div class="gradient-extendido-div">
          <ion-label class="color-title"> {{'Histórico de Migração' | translate}} </ion-label>
        </div>
        <ion-row class="ion-margin-end">
          <ion-col class="ion-margin-start">
            <ion-select
              interface="action-sheet"
              cancelText="{{ 'Cancelar' | translate}}"
              okText="{{ 'Confirmar' | translate}}"
              formControlName="historico"
              label-placement="stacked"
            >
              <div slot="label" class="label-normal">
                {{ (isVisitanteGrupos ? 'Ocorrência' : 'Histórico') | translate }}<ion-text color="danger">*</ion-text>
              </div>

              <ion-select-option *ngFor="let v of historicoList" [value]="v.id">{{v.nome}}</ion-select-option>
            </ion-select>

            <div class="validation-errors">
              <ng-container *ngFor="let validation of validation_messages.historico">
                <div
                  class="error-message"
                  *ngIf="validations_form.get('historico')?.hasError(validation.type) && (validations_form.get('historico')?.dirty)"
                >
                  {{ validation.message }}
                </div>
              </ng-container>
            </div>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col>
            <prover-datepicker
              [labelName]="dataLabel"
              [id]="'dataHistorico'"
              formControlName="dataHistorico"
              [required]="true"
              [isDataAtual]="false"
              [disabled]="validations_form.get('dataHistorico')?.disabled ?? false"
            ></prover-datepicker>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col class="ion-margin-start">
            <ion-label style="font-size: 14px" position="floating">{{'Anotação' | translate}}</ion-label>
            <ion-textarea
              rows="2"
              cols="60"
              type="text"
              formControlName="observacaoHistorico"
              placeholder="{{'Anotação' | translate}}"
            ></ion-textarea>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>

    <div style="padding: 40px">
      <ion-button class="btn-default" expand="block" type="submit" [disabled]="!validations_form.valid">
        {{'Migrar' | translate}}
      </ion-button>
    </div>
  </form>
</ion-content>
